import { salesApiInstance } from './client.js';

export const citiesApi = {
  getAll:  ()          => salesApiInstance.get('/cities').then(r => r.data),
  create:  (data)      => salesApiInstance.post('/cities', data).then(r => r.data),
  update:  (id, data)  => salesApiInstance.put(`/cities/${id}`, data).then(r => r.data),
  delete:  (id)        => salesApiInstance.delete(`/cities/${id}`).then(r => r.data),
};
